module.exports = __webpack_public_path__ + "static/media/waiting_avatar.7f00520e.svg";